import { render, staticRenderFns } from "./DiscountOnSupplyPriceRule.vue?vue&type=template&id=db67cb9a&scoped=true"
import script from "./DiscountOnSupplyPriceRule.vue?vue&type=script&lang=js"
export * from "./DiscountOnSupplyPriceRule.vue?vue&type=script&lang=js"
import style0 from "./DiscountOnSupplyPriceRule.vue?vue&type=style&index=0&id=db67cb9a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db67cb9a",
  null
  
)

export default component.exports